// Staff screen at power-on. One tap grants the camera permission, which iOS
// only allows from a user gesture. Visitors never see this. Markup and
// classes from the design pass (docs/design).
import { t, onLanguageChange } from '../i18n/index.js';
import { el } from '../debug/controls.js';
import { ICON_CAMERA } from './icons.js';

export function createStartScreen(app, { onStart }) {
  const icon = el('div', { class: 'staff__icon' });
  icon.innerHTML = ICON_CAMERA;
  const title = el('h1', { class: 'staff__title' });
  const sub = el('p', { class: 'staff__sub' });
  const button = el('button', { class: 'staff staff--start', type: 'button' }, [icon, title, sub]);
  const root = el('div', { class: 'mw-staff-layer' }, [button]);

  const render = () => {
    title.textContent = t('start.tap');
    sub.textContent = t('start.hint');
  };
  render();
  onLanguageChange(render);

  let busy = false;
  button.addEventListener('pointerdown', () => button.classList.add('is-pressed'));
  for (const type of ['pointerup', 'pointercancel', 'pointerleave']) {
    button.addEventListener(type, () => button.classList.remove('is-pressed'));
  }
  button.addEventListener('click', async () => {
    if (busy) return;
    busy = true;
    try {
      await onStart();
    } finally {
      busy = false;
    }
  });

  app.append(root);
  return {
    show: () => (root.hidden = false),
    hide: () => (root.hidden = true),
  };
}
